export default "__VITE_ASSET__uPOyZVyJ__"